// extracted by mini-css-extract-plugin
module.exports = {"graphic":"FAQStaking_graphic_1dQpr"};